import { CalendarDate } from '@internationalized/date';

export function isDateInputDate(date: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(date);
}

export function getISODate(dateString: string | undefined) {
  try {
    const date = !dateString ? new Date() : new Date(dateString);
    return date.toISOString();
  } catch (error) {
    console.error(error);
    return null;
  }
}

/**
 * Si no pasamos prop asumimos que es la fecha actual
 */
export function getCalendarDate(date?: Date) {
  const dateToUse = date ?? new Date();
  return new CalendarDate(dateToUse.getFullYear(), dateToUse.getMonth() + 1, dateToUse.getDate());
}

export function getNow() {
  return new Date().toISOString();
}
